export default __webpack_public_path__ + "static/bg-tech-nation-daad3ad73e5f35e2d1f94c2930bee2b6.png";